module.exports = __webpack_public_path__ + "static/img/zixun.1253235.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zixun.png
// module id = Mgd0
// module chunks = 128